<template>
  <CustomerFormBase
    v-model="localCustomer"
    :address2="address2"
    :addressError="addressError"
    :showBirthInfo="false"
    :showAddress="true"
    @update:address2="$emit('update:address2', $event)"
    @newAddress="$emit('newAddress', $event)"
  />
</template>

<script>
import CustomerFormBase from "@/components/pos/subscription/form/CustomerFormBase.vue";

export default {
  components: {
    CustomerFormBase,
  },
  props: {
    modelValue: Object,
    address2: String,
    addressError: Boolean,
  },
  computed: {
    localCustomer: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
